import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LoadingSpinner from './components/LoadingSpinner';
import { getUserApi } from './api/api';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  Addresses,
  Authorization,
  Controllers,
  Engineers,
  Events,
  Invitation,
  QuickRegistration,
  Reports,
  Reset,
  Summary,
  User,
  Users,
  Verify,
  Permissions,
  Payments,
  FirmwareUpdatePolicies,
  FirmwareTest,
  OtaEvents,
  MetronDevices,
  Risks,
  Support,
  RisksDeviceHistory,
} from './pages';
import EngineerRegistration from './pages/EngineerRegistration';
import { useUserStore } from './stores/use-user-store';
import SidebarLayout from './features/layouts/SidebarLayout';
import useRole from './hooks/use-role';
import AuthLayout from './features/layouts/AuthLayout';
import Integrations from './pages/Integrations';
import ArchiveIntegrations from './pages/ArchiveIntegrations';

let setAuthorizedEvent = () => {};

const App = () => {
  const { setUser, authorized, setAuthorized } = useUserStore();
  const { isMeridianOrg, isEngineer } = useRole();
  const [loading, setLoading] = React.useState(true);

  setAuthorizedEvent = (status) => {
    setAuthorized(status);
  };

  React.useEffect(() => {
    const fetchData = async () => {
      getUserApi(
        async (data) => {
          setUser(data);
          setAuthorized(true);
          setLoading(false);
        },
        (err) => {
          setAuthorized(false);
          setLoading(false);
        }
      );
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="flex min-h-screen w-full p-1 overflow-y-scroll overflow-x-hidden items-center justify-center bg-gradient-to-r from-[#ededed] to-[#dcdcdc]">
        <LoadingSpinner loading={true} />
      </div>
    );
  }

  return (
    <>
      <Routes>
        {/* Private routes with sidebar */}
        {authorized && (
          <Route element={<SidebarLayout />}>
            <Route path="/" element={<Summary />} />
            <Route path="/users" element={<Users />} />
            <Route path="/support" element={<Support />} />
            <Route path="/engineers" element={<Engineers />} />
            <Route path="/events" element={<Events />} />
            {isMeridianOrg && <Route path="/ota-events" element={<OtaEvents />} />}
            {isMeridianOrg && <Route path="/metron-devices" element={<MetronDevices />} />}
            {isMeridianOrg && !isEngineer && <Route path="/firmware-test" element={<FirmwareTest />} />}
            <Route path="/addresses" element={<Addresses />} />
            <Route path="/controllers" element={<Controllers />} />
            <Route path="/integrations" element={<Integrations />} />
            <Route path="/archiveIntegrations" element={<ArchiveIntegrations />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/risks" element={<Risks />} />
            <Route path="/risks/devices/:deviceId/history" element={<RisksDeviceHistory />} />
            <Route path="/payments" element={<Payments />} />
            <Route path="/quick-registration" element={<QuickRegistration />} />
            <Route path="/invitation" element={<Invitation />} />
            <Route path="/roles-and-permissions" element={<Permissions />} />
            <Route path="/devices-update" element={<FirmwareUpdatePolicies />} />
            <Route path="/user" element={<User />} />
          </Route>
        )}

        {/* Public routes without sidebar */}
        <Route element={<AuthLayout />}>
          <Route path="/verify" element={<Verify />} />
          <Route path="/resetpass" element={<Reset />} />
          <Route path="/engineerRegistration" element={<EngineerRegistration />} />
          {!authorized && <Route path="*" element={<Authorization />} />}
        </Route>
      </Routes>

      <ToastContainer />
    </>
  );
};

export { setAuthorizedEvent };
export default App;
